import common from '@/services/common'
import qs from "qs"

export default {
  getFiles(path) {
    const queryParams = {
      path: path ? path : null,
    }
    return common.executeExternal("get",
      `${process.env.VUE_APP_MOBILE_UTIL_PAGES_CLOUD_FUNCTION_BASE_URL}?${qs.stringify(queryParams, { encode: false, skipNulls: true })}`,
    ).then(result => result.files)
  },
}